import {
    UserController, StripeController
} from "controllers";

export const handleCancelItemSubscription = async (customer, subscriptionId) => {
    const itemSubscription = customer.stripe.single_item_subscriptions.find((sis) => sis.subscription_id === subscriptionId);

    await StripeController.cancelAnySubscription({ uid: customer.id, subscriptionId });
    // update stripe

    itemSubscription.status = "canceled";
    itemSubscription.canceled_at = +new Date();
    itemSubscription.canceled_from = 'Tidie';

    await UserController.addStripeSubscription(customer.id, { stripe: customer.stripe });
}

